export default __webpack_public_path__ + "static/media/Ganesh deshmukh.c21a565b.jpeg";